module.exports = __webpack_public_path__ + "static/media/YF97_1.a4e715d9.jpg";